<template>
  <v-dialog v-model="dialog" max-width="980px">
    <v-card>
      <v-card-title class="mx-3">
          <span
            class="d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("ThirdApiSetting.kry_shop_title")
            }}
          </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <ValidationObserver ref="observer">
      <v-card-text class="px-4 pt-8">
        <v-row align="center">
          <v-col cols="3" class="font-weight-bold text-right">
            {{ $t("ThirdApiSetting.kry_app_key") + $t("Global.colon") }}
            <Required :show="true" mode="edit" />
          </v-col>
          <v-col cols="9" md="7">
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('ThirdApiSetting.kry_app_key')"
              rules="required"
            >
              <v-text-field
                single-line
                v-model="appKey"
                :error-messages="errors" />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3" class="font-weight-bold text-right">
            {{ $t("ThirdApiSetting.kry_shop_identy") + $t("Global.colon") }}
            <Required :show="true" mode="edit" />
          </v-col>
          <v-col cols="9" md="7">
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('ThirdApiSetting.kry_shop_identy')"
              rules="required"
            >
              <v-text-field
                single-line
                v-model="shopIdenty"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3" class="font-weight-bold text-right">
            {{ $t("ThirdApiSetting.kry_token") + $t("Global.colon") }}
            <Required :show="true" mode="edit" />
          </v-col>
          <v-col cols="9" md="7">
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('ThirdApiSetting.kry_token')"
              rules="required"
            >
              <v-text-field
                single-line
                v-model="token"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3" class="font-weight-bold text-right">
            {{ $t("ThirdApiSetting.kry_version") + $t("Global.colon") }}
            <Required :show="true" mode="edit" />
          </v-col>
          <v-col cols="9" md="7">
            <v-text-field single-line disabled="disabled" v-model="version" />
          </v-col>
        </v-row>
      </v-card-text>
      </ValidationObserver>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          @click="save()"
        >
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "DialogShops",

  components: {
    Required,
    ValidationObserver,
    ValidationProvider
  },

  props: {
    value: Boolean,
    setting: Object,
    shop: Object,
  },

  computed: {

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    appKey: null,
    shopIdenty: null,
    token: null,
    version: "2.0",
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog && this.setting) {
          // 每次打开对话框重置查询
          this.appKey = this.setting.appKey
          this.shopIdenty = this.setting.shopIdenty
          this.token = this.setting.token
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.appKey = null
          this.shopIdenty = null
          this.token = null
          this.$refs.observer.reset();
        }
      },
    },
  },

  methods: {
    save() {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            let ret = {
              appKey: this.appKey,
              shopIdenty: this.shopIdenty,
              token: this.token,
              version: this.version,
              shop_code: this.shop.shop_code,
              shop_id: this.shop.id,
            }
            this.$emit('confirm', ret);
            this.dialog = false
          }
        }.bind(this)
      );
    }
  },
};
</script>
